export enum StorageKeys {
    EVENTIO_CART_ID = "eventio_cart_id",
    EVENTIO_CART_TOKEN = "eventio_cart_token",
    EVENTIO_CHECKOUT_ID = "eventio_checkout_id",
    EVENTIO_PAYMENT_PENDING = "eventio_payment_pending",
}
